module.exports = __webpack_public_path__ + "static/media/error.3f2142af.svg";